(function(){
    'use strict'

    angular
    .module('app.reportes')
    .controller('reportes.Ordenes', Ordenes);

    Ordenes.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Ordenes($animationsSrv, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        ApiBaseService.remoteController = 'api/Ordenes'

        const companiaId = UserInfoService.getCompaniaId();

        var vm = this;

        vm.busqueda = {
            estado:0,
            contratoId: 0,
            clienteId: 0,
            proyectoId: 0,
            centroCostoId: 0,
            empresaFumigadoraId: 0,
            fechaDesde: moment().toDate(), 
            fechaHasta: moment().toDate()
        };

        vm.clientes = [];
        vm.proyectos = [];
        vm.centrosCosto = [];
        vm.contratos = [];
        vm.empresasFumigadoras = [];

        vm.collection = [];
        vm.title = 'Reporte Ordenes de Servicio';

        vm.openFechaDesde = function(){
            vm.fechaDesdeOpened = !vm.fechaDesdeOpened;
        };

        vm.openFechaHasta = function(){
            vm.fechaHastaOpened = !vm.fechaHastaOpened;
        };

        const promiseContratos = getComboData(vm.contratos, 'api/Contratos', [companiaId], 'Error al obtener los contratos.');
        const promiseClientes = getComboData(vm.clientes, 'api/Clientes', [companiaId], 'Error al obtener los clientes.');
        const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos', [companiaId], 'Error al obtener los proyectos.');
        const promiseEmpresasFumigadoras = getComboData(vm.empresasFumigadoras, 'api/Empresas-Fumigadoras', [companiaId], 'Error al obtener las empresas fumigadoras.');
        const promiseCentrosCosto = getComboData(vm.centrosCosto, 'api/CentrosCosto', [companiaId], 'Error al obtener los centros de costo.');

        vm.goToEdit = function(data){
            
            var path = '/editar-orden/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            } 
        };

        vm.goToFirmar = function(data){
            
            var path = '/firmar-orden/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                logger.error('Accion Invalida!!!');
            } 
        };

        vm.goToAnular = function(data){
            
            var path = '/anular-orden/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                logger.error('Accion Invalida!!!');
            } 
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.getDescripcionBotonFirmar = function(item){
            switch (item.estado) {
                case 1:
                    return 'Firmar';
                case 2:
                case 3:
                    return 'Ver Firma';
                case 4:
                    return item.firmaData != null ? 'Ver Firma' : 'Firmar';
                default:
                    return '';
            }
        };

        vm.getDescripcionBotonAnular = function(item){
            switch (item.estado) {
                case 1:
                case 2:
                    return 'Anular';
                case 4:
                    return 'Ver Anulacion';
                default:
                    return '';
            }
        };

        getAll();

        vm.getAll = function()
        {
            getAll();
        };

        function getAll(){

            ApiBaseService.remoteController = 'api/Ordenes'

            const fechaDesde = moment(vm.busqueda.fechaDesde);
            const fechaHasta = moment(vm.busqueda.fechaHasta);

            const params = [companiaId,
                            vm.busqueda.estado,
                            vm.busqueda.contratoId,
                            vm.busqueda.clienteId,
                            vm.busqueda.proyectoId,
                            vm.busqueda.centroCostoId,
                            vm.busqueda.empresaFumigadoraId,
                            fechaDesde.isValid() ? fechaDesde.format('YYYY-MM-DD') : null,
                            fechaHasta.isValid() ? fechaHasta.format('YYYY-MM-DD') : null];
            var promise = ApiBaseService.getAll(params);

            promise
            .then(function(collection){

                collection.forEach((c)=>{
                    c.verDetalle =  false;
                    c.total = 0;

                });

                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.getDetalleAll = function(item)
        {
            if(!item.detalle || item.detalle.length == 0)
            {
                item.detalle = [];
                getComboData(item.detalle, 'api/Ordenes/DetalleAll', [companiaId, item.id], 'Error al obtener los detalles.');
            }
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Ordenes'
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        vm.deleteDetalle = function(data){
            ApiBaseService.remoteController = 'api/Ordenes/Detalle'
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){

                const item = vm.collection.find((c)=>c.id == data.ordenId);

                if(item)
                {
                    item.detalle = item.detalle.filter(function(g) {
                    return g.id !== data.id;
                    });
                }

                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

        function minutos(horaInicio, horafin)
        {
            return moment(horafin).diff(moment(horaInicio), 'minutes');
        }

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        vm.clearCriteria = function()
        {
            vm.busqueda = {
                estado:0,
                contratoId: 0,
                clienteId: 0,
                proyectoId: 0,
                centroCostoId: 0,
                empresaFumigadoraId: 0,
                fechaDesde: null, 
                fechaHasta: null
            }
        }

        vm.getExcel = function()
        {
            ApiBaseService.remoteController = 'api/Ordenes/excel'

            const fechaDesde = moment(vm.busqueda.fechaDesde);
            const fechaHasta = moment(vm.busqueda.fechaHasta);

            const params = [companiaId,
                            vm.busqueda.estado,
                            vm.busqueda.contratoId,
                            vm.busqueda.clienteId,
                            vm.busqueda.proyectoId,
                            vm.busqueda.centroCostoId,
                            vm.busqueda.empresaFumigadoraId,
                            fechaDesde.isValid() ? fechaDesde.format('YYYY-MM-DD') : null,
                            fechaHasta.isValid() ? fechaHasta.format('YYYY-MM-DD') : null];
            var promise = ApiBaseService.getFile(params);

            promise
            .then(function(result){
                logger.info('Excel descargado!');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });        
        };

    }
})();